export default "__VITE_ASSET__FB9$eRmL__"